<template>
	<div class="wrap">
		<div class="content">
			<ByIcon icon="oops" size="300" />
			<h2>Oops</h2>
			<p>此頁面已失效</p>
			<p>開始美好的訂餐體驗吧！</p>
		</div>
		<ByFooter />
	</div>
</template>

<script>
import { defineComponent } from 'vue'
import ByIcon from '../../components/Icon.vue'
import ByFooter from '../../components/Footer.vue'

export default defineComponent({
	components: { ByFooter, ByIcon },
})
</script>

<style lang="sass" scoped>
.wrap
	+fc
	width: 100%
	min-height: 100%
	flex-direction: column
	transform: translateY(-25px)

.content
	flex: 1
	display: flex
	align-items: center
	justify-content: center
	flex-direction: column
	padding: 25px 0

h2
	margin: 10px 0 15px 0
	font-size: 32px

p
	line-height: 1.5
	font-size: 16px
</style>
